import type { ContentTocLink } from '#ui/types';

type StoryblokRichTextMark = {
    type: string;
    attrs?: Record<string, unknown>;
};

type StoryblokRichTextNode = {
    type: string;
    text?: string;
    marks?: StoryblokRichTextMark[];
    attrs?: Record<string, unknown>;
    content?: StoryblokRichTextNode[];
};

export type StoryblokRichTextDoc = {
    type: 'doc';
    content?: StoryblokRichTextNode[];
};

export type UseStoryblokBlogTocReturn = ComputedRef<ContentTocLink[]>;

export const useStoryblokBlogToc = (doc: MaybeRefOrGetter<StoryblokRichTextDoc | undefined>): UseStoryblokBlogTocReturn => {
    return computed(() => {
        const document = toValue(doc);

        return (document?.content ?? []).reduce<ContentTocLink[]>((acc, node) => {
            if (node.type !== 'heading' || node.attrs?.['level'] !== 2) {
                return acc;
            }

            const textNodes = node.content ?? [];
            const text = textNodes.map(n => n.text ?? '').join('');
            const anchorMark = textNodes.flatMap(n => n.marks ?? []).find(m => m.type === 'anchor');
            const id = anchorMark?.attrs?.['id'];

            if (typeof id !== 'string' || !id) {
                return acc;
            }

            acc.push({ id, text, depth: 2 });

            return acc;
        }, []);
    });
};
